import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentProjectId } from '../use-get-current-project-id';

/**
 * ### useGetCurrentProject
 * @description
 * Hook that fetches the current project data based on the current project ID
 * @example
 * const { data: project, isLoading, error } = useGetCurrentProject();
 * @returns Object containing the project data, loading state, and any error that occurred
 */
const useGetCurrentProject = () => {
  const currentProjectId = useGetCurrentProjectId();
  const {
    data: project,
    error,
    isLoading,
  } = projectApi.useGetProjectsByProjectIdQuery(
    { projectId: currentProjectId ?? -1 },
    { skip: !currentProjectId },
  );

  return {
    data: project,
    isLoading,
    error,
  };
};

export default useGetCurrentProject;
